import * as $ from "jquery";
import * as Modernizr from "../../lib/modernizr-3.5.0.min.js";
import * as AOS from "aos";
import * as Rellax from "rellax";
import * as scrollama from "scrollama";
import * as TweenLite from "gsap/TweenLite";

/* Parallax and interactive animations */
function initParallax() {
	if (Modernizr.mq('(max-width: 767px)')) {
		return;
	}

	if($('.rellax').length) {
		if(!Modernizr.ie11) {
			new Rellax('.rellax', {
				center: true
			});
		}
	}

	function handleScrollCallback(action, callback) {
		// callback = { element: DOMElement, index: number, direction: string }
		let $el = $(callback.element);
		let scrollActions = (action === 'enter') ? $el.data('scroll-enter') : $el.data('scroll-exit');

		if (!scrollActions) {
			return;
		}

		if (typeof(scrollActions) === 'string') {
			scrollActions = [{
				action: scrollActions,
				target: $el.data('target'),
				delay: $el.data('delay') || 0
			}];
		}

		for (var i = 0; i < scrollActions.length; i++) {
			let nextSequence = scrollActions[i];
			let nextAction = nextSequence.action;
			let $nextTarget = $el.find(nextSequence.target) || $el;
			let delay = nextSequence.delay || 0;

			switch (nextAction) {
				case 'applyClass':
				case 'apply-class':
				case 'add_class':
					TweenLite.delayedCall(delay, function () {
						let scrollClass = nextSequence.class || $el.data('scroll-class');
						$nextTarget.addClass(scrollClass);
					});
					break;
				case 'removeClass':
				case 'remove-class':
				case 'remove_class':
					TweenLite.delayedCall(delay, function () {
						let scrollClass = nextSequence.class || $el.data('scroll-class');
						$nextTarget.removeClass(scrollClass);
					});
					break;
				case 'playVideo':
				case 'play_video':
					$nextTarget.get(0).play();
					break;
				case 'pauseVideo':
				case 'pause_video':
					$nextTarget.get(0).pause();
					break;
				case 'playFramestack':
				case 'play_framestack':
					$nextTarget.jsMovie('play');
					break;
				case 'pauseFramestack':
				case 'pause_framestack':
					$nextTarget.jsMovie('pause');
				case 'ping':
					pingTargets($nextTarget);
					break;
			}
		}

	}

	function handleScrollEnter(callback) {
		handleScrollCallback('enter', callback);
	};

	function handleScrollExit(callback) {
		handleScrollCallback('exit', callback);
	};

	let scroller = scrollama();

	if ( $('.step').length ) {
		scroller.setup({
			step: '.step',
		}).onStepEnter(handleScrollEnter).onStepExit(handleScrollExit);
	}
}

function initTriggeredInteractions() {
	$('[data-trigger]').on('click', function (e) {
		e.preventDefault();

		var $this = $(this);
		var action = $this.data('trigger');
		var $target = $($this.data('target'));

		switch (action) {
			case 'play-video':
			case 'playVideo':
				$target.get(0).play();
				break;
		}
	});
};

function pingTargets($targets) {
	let i = 0;
	let delay = 1;

	$targets.each(function () {
		let $nextTarget = $(this);

		TweenLite.delayedCall(delay * i, function () {
			$nextTarget.trigger('mouseenter');
		});
		i++;
	});
}

export function init() {
	AOS.init({
		easing: 'ease-out-quad',
		duration: 500,
		disable: window.innerWidth < 768
	});

	initParallax();
	initTriggeredInteractions();
}



// WEBPACK FOOTER //
// ./js/PFF/modules/scrollEffects.ts